import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
   Button, ButtonToolbar, Modal, Table, UncontrolledTooltip, FormGroup,
} from 'reactstrap';
import ReactPaginate from 'react-paginate';
import swal from 'sweetalert';
import { reduxForm } from 'redux-form';
import CommonService from '../../services/CommonService';
import global from '../../global';

class AddPaymentModal extends PureComponent {
   static propTypes = {
      modal: PropTypes.bool,
      title: PropTypes.string,
      toggle: PropTypes.func.isRequired,
      id: PropTypes.oneOfType([
         PropTypes.string,
         PropTypes.number,
      ]).isRequired,
      identifier: PropTypes.string,
   };

   static defaultProps = {
      modal: false,
      title: '',
      identifier: 'customer',
   };

   constructor() {
      super();
      this.perPage = 7;
      this.state = {
         list: [],
         realList: [],
      };
      this.updatePaymentStatus = this.updatePaymentStatus.bind(this);
      this.handleClick = this.handleClick.bind(this);
   }

   componentDidMount() {
      const { id, identifier } = this.props;
      this.isLoading = true;
      this.onLoadPayments(id, identifier);
   }

   componentWillReceiveProps(nextProps) {
      this.isLoading = true;
      this.onLoadPayments(nextProps.id, nextProps.identifier);
   }

   componentWillUnmount() {
      this.isLoading = false;
   }

   updatePaymentStatus = (e, payid) => {
      e.preventDefault();
      swal({
         title: 'Confirmation',
         text: 'Are you sure you want to archive this payment?',
         icon: 'warning',
         closeOnClickOutside: false,
         buttons: {
            yes: 'YES',
            no: 'NO',
         },
      }).then((name) => {
         name = name.toLowerCase();
         const customerdata = { paymentid: payid };

         if (name === 'yes') {
            CommonService.updateData('archivepayment', customerdata).then((response) => {
               if (response !== true) {
                  swal('', 'Something went wrong!', 'error');
               } else {
                  window.location.reload();
               }
            }).catch((error) => {
               console.log(error);
            });
         }
      });
   }

   onLoadPayments = async (id, identifier) => {
      let urlId = `/customerid/${id}`;
      if (identifier === 'supplier') {
         urlId = `/supplierid/${id}`;
      }

      try {
         this.isLoading = true;
         const response = await CommonService.getRows(`paymentlists${urlId}`);
         if (response !== '') {
            this.setState({ list: response, realList: response });
            this.handleClick();
         }
      } catch (err) {
         console.log('Error: ', err.message);
      }
      this.isLoading = false;
   }

   handleClick(event = '') {
      const selected = event !== '' ? event.selected + 1 : 1;
      const { realList } = this.state;

      const lastPost = selected * this.perPage;
      const firstPost = lastPost - this.perPage;

      const newList = realList.slice(firstPost, lastPost);
      this.setState({ list: newList });
   }

   render() {
      const {
         modal, toggle, identifier, title,
      } = this.props;
      const { list, realList } = this.state;

      return (
         <div>
            <Modal
               isOpen={modal}
               className="modal-dialog--primary modal-dialog--header"
            >
               <div className="modal__header bg_blue">
                  <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggle} />
                  <h4 className="bold-text  modal__title">{title !== '' ? title : 'Payment Lists'}</h4>
               </div>
               <div className="modal__body p-t-10">
                  <Table className="no_hover" id="payments_table" responsive>
                     <thead>
                        <tr>
                           <th>Amount</th>
                           {
                              identifier === 'customer' && (
                                 <th className="text-center">Payment Type</th>
                              )
                           }
                           <th className="text-center">Date Paid</th>
                           {/* <th className="text-center">Action</th> */}
                        </tr>
                     </thead>
                     <tbody>
                     {
                        list !== false || list.length > 0 ? list.map((item, key) => (
                           <tr key={`paymentList${key + 1}`}>
                              <td className="text-green"><span className="m-r-2">&#x20B1;</span> {item.amount ? parseFloat(item.amount, 10).toFixed(2) : 0}</td>
                              {
                                 identifier === 'customer' && (
                                    <td className="text-center">{item.payment_type ? global.paymentType[item.payment_type] : '-'}</td>
                                 )
                              }
                              <td className="text-center">{item.payment_date}</td>
                              <td className="text-center">
                                 {
                                 /* Edit */
                                    item.payment_status === '22' && (
                                       <>
                                          {/* Archive payment */}
                                          <Button color="danger" className="btn-xs" onClick={e => this.updatePaymentStatus(e, item.payment_id)} id={`paytrash${key + 1}`} outline><span className="fa fa-archive" /></Button>
                                          <UncontrolledTooltip placement="bottom" target={`paytrash${key + 1}`}>Payment Archive</UncontrolledTooltip>
                                       </>
                                    )
                                 }
                              </td>
                           </tr>
                        )) : (
                           <tr className="text-center">
                              <td colSpan="3"><i>No payments available..</i></td>
                           </tr>
                        )
                     }
                     </tbody>
                  </Table>
                  <FormGroup className={list === false || (realList.length / this.perPage) <= 1 ? 'display-none' : ''}>
                     <ReactPaginate
                        previousLabel="<<"
                        nextLabel=">>"
                        breakLabel="..."
                        breakClassName="break-me"
                        pageCount={realList.length / this.perPage}
                        onPageChange={this.handleClick}
                        marginPagesDisplayed={0}
                        pageRangeDisplayed={2}
                        containerClassName="list-pagination"
                        activeClassName="active"
                     />
                  </FormGroup>
               </div>
               <ButtonToolbar className="modal__footer">
                  <Button onClick={toggle}>Close</Button>
               </ButtonToolbar>
            </Modal>
         </div>
      );
   }
}

export default reduxForm({
  form: 'AddPaymentModal', // a unique identifier for this form
})(AddPaymentModal);
